module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Productos relacionados con el Canal de Isabel II":"Productos relacionados con el Canal de Isabel II","Error":"Error"},"en":{"Productos relacionados con el Canal de Isabel II":"Products related to the Canal de Isabel II","Error":"Error"}}')
  delete Component.options._Ctor
}
